"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torre-del-greco": {
    "0a166e57": [{
      "hkey": "f4297e8d",
      "slug": "centro-santa-teresa",
      "name": "Centro-Santa Teresa",
      "primary": true,
      "skipSearch": false
    }],
    "calastro": [{
      "hkey": "f4297e8d",
      "slug": "centro-santa-teresa",
      "name": "Centro-Santa Teresa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "74c622f8": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "skipSearch": false
    }],
    "camaldoli": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e242ebad": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "skipSearch": false
    }],
    "cappella-bianchini": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torre-del-greco"
    }],
    "2a97f77e": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "skipSearch": false
    }],
    "cappella-carotenuto": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torre-del-greco"
    }],
    "be13f816": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "skipSearch": false
    }],
    "cappella-nuova": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torre-del-greco"
    }],
    "a879f6ad": [{
      "hkey": "c3eb834b",
      "slug": "leopardi-litoranea-santa-maria-la-bruna",
      "name": "Leopardi-Litoranea-Santa Maria la Bruna",
      "primary": true,
      "skipSearch": false
    }],
    "leopardi": [{
      "hkey": "c3eb834b",
      "slug": "leopardi-litoranea-santa-maria-la-bruna",
      "name": "Leopardi-Litoranea-Santa Maria la Bruna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torre-del-greco"
    }],
    "993b3a69": [{
      "hkey": "c3eb834b",
      "slug": "leopardi-litoranea-santa-maria-la-bruna",
      "name": "Leopardi-Litoranea-Santa Maria la Bruna",
      "primary": true,
      "skipSearch": false
    }],
    "litoranea": [{
      "hkey": "c3eb834b",
      "slug": "leopardi-litoranea-santa-maria-la-bruna",
      "name": "Leopardi-Litoranea-Santa Maria la Bruna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torre-del-greco"
    }],
    "30d422f3": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "skipSearch": false
    }],
    "montedoro": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torre-del-greco"
    }],
    "192aeae5": [{
      "hkey": "c3eb834b",
      "slug": "leopardi-litoranea-santa-maria-la-bruna",
      "name": "Leopardi-Litoranea-Santa Maria la Bruna",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-della-gatta": [{
      "hkey": "c3eb834b",
      "slug": "leopardi-litoranea-santa-maria-la-bruna",
      "name": "Leopardi-Litoranea-Santa Maria la Bruna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torre-del-greco"
    }],
    "58ac1169": [{
      "hkey": "b5f75df2",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "portosalvo": [{
      "hkey": "b5f75df2",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a0544624": [{
      "hkey": "c3eb834b",
      "slug": "leopardi-litoranea-santa-maria-la-bruna",
      "name": "Leopardi-Litoranea-Santa Maria la Bruna",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-la-bruna": [{
      "hkey": "c3eb834b",
      "slug": "leopardi-litoranea-santa-maria-la-bruna",
      "name": "Leopardi-Litoranea-Santa Maria la Bruna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "44420a9f": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "skipSearch": false
    }],
    "scappi": [{
      "hkey": "2e2da9fa",
      "slug": "camaldoli-montedoro-nicola",
      "name": "Camaldoli-Montedoro-Nicola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "torre-del-greco"
    }]
  }
};
exports["default"] = _default;